import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import StandardModal from 'shared/StandardModal.jsx';
import StandardField from 'shared/StandardField.jsx';

const required = value => value ? undefined : 'Required';

const EditAccountModal = ({
  visible,
  onCancel,
  handleSubmit,
  onSubmit
}) =>(
  <StandardModal
    title="Stripe Connect Account Name"
    visible={visible}
    onCloseClick={onCancel}>
      <div>
        <form id="editAccountForm"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-group">
            <Field
              name="accountName"
              type="text"
              component={StandardField}
              label="Account Name"
              placeholder="Enter account name..."
              validate={[required]}
            />
          </div>
          <div className="form-group text-right">
              <button 
                type="button"
                className="btn btn-link"
                onClick={() => onCancel()}
              >{'Cancel'}</button>
              {` `}
              <button
                type="submit"
                className="btn btn-primary btn-lg"
              >{'Save'}</button>
          </div>
        </form>
      </div>
    </StandardModal>
);

EditAccountModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onSubmit: PropTypes.func
};

export default reduxForm({
  form: 'editAccountForm'
})(EditAccountModal);


// WEBPACK FOOTER //
// ./src/features/finance/accounts/EditAccountModal.jsx